const createListItem = (text: string): string => {
  return `<li class='app-tooltip-list-item'>
    ${text}
  </li>`;
};

export const permissionsTooltips: any = {
  productCatalogView: `<ul class='app-tooltip-list'>
    ${createListItem('A user can search Product catalog Published Catalog')}
    ${createListItem('A user can create & view lists')}
    ${createListItem('A user can view all segments in Detail and ECommerce, but has no access to the Panel')}
  </ul>`,
  damView: `<ul class='app-tooltip-list'>
    ${createListItem('A user can search Digital Asset Manager')}
    ${createListItem('A user can create & view lists')}
    ${createListItem('A user can view all segments in Digital Asset Detail, but has no access to change them')}
  </ul>`,
  fitmentsView: false,
  productCatalogEdit: false,
  damEdit: false,
  fitmentsEdit: false,
};
